{
  "title": "Alarm",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration (ritual)",
  "level": 1,
  "castingTime": "1 minute",
  "range": "30 feet",
  "components": "V, S, M (a tiny bell and a piece of fine silver wire)",
  "duration": "8 hours",
  "description": [
    "You set an alarm against unwanted intrusion. Choose a door, a window, or an area within range that is no larger than a 20-foot cube. Until the spell ends, an alarm alerts you whenever a tiny or larger creature touches or enters the warded area. When you cast the spell, you can designate creatures that won’t set off the alarm. You also choose whether the alarm is mental or audible.",
    "A mental alarm alerts you with a ping in your mind if you are within 1 mile of the warded area. This ping awakens you if you are sleeping. An audible alarm produces the sound of a hand bell for 10 seconds within 60 feet."
  ],
  "spellLists": ["artificer", "eldritch-knight", "ranger", "wizard"]
}
